export default __webpack_public_path__ + "static/forschungsstelle-osteuropa-a36a253eff126c4bbfc738ec1e35863d.svg";